// extracted by mini-css-extract-plugin
export var addButton = "_ni-0";
export var border = "_ni-8";
export var check = "_ni-h";
export var danger = "_ni-6";
export var dropdownContainer = "_ni-1";
export var editModalBody = "_ni-j";
export var footerContainer = "_ni-i";
export var fullWidth = "_ni-a";
export var hide = "_ni-9";
export var icon = "_ni-3";
export var input = "_ni-7";
export var inputFlex = "_ni-b";
export var inputWrapper = "_ni-c";
export var manualFocus = "_ni-5";
export var optionButton = "_ni-4";
export var pillWrapper = "_ni-e";
export var pointer = "_ni-2";
export var showOverflow = "_ni-f";
export var tagsFlex = "_ni-d";
export var xButton = "_ni-g";